import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";

/* this file is transformed by vux-loader */

/* eslint-disable */
import _createForOfIteratorHelper from "D:/we-dev/mobile_v2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js"; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UploadImage from '@/components/UploadImage/UploadImage';
import Group from 'vux/src/components/group';
import Cell from 'vux/src/components/cell';
import Previewer from 'vux/src/components/previewer';
import XButton from 'vux/src/components/x-button';
import XTextarea from 'vux/src/components/x-textarea';
import ViewBox from 'vux/src/components/view-box';
import TransferDom from 'vux/src/directives/transfer-dom';
import Rater from 'vux/src/components/rater';
export default {
  name: 'RepairAppInfo',
  components: {
    Cell: Cell,
    Group: Group,
    XButton: XButton,
    ViewBox: ViewBox,
    XTextarea: XTextarea,
    Previewer: Previewer,
    Rater: Rater,
    UploadImage: UploadImage
  },
  data: function data() {
    return {
      doneImgList: [],
      //图片列表数组
      showImgList: [],
      limitNum: 5,
      //最多上传图片张数
      imgList: [],
      //图片列表数组
      repairInfo: {
        dicFmtMap: {
          repairTypeCn: ''
        }
      },
      repairRemark: '',
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          var pageYScroll = window.scrollY || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      },
      optionsSecond: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img-second')[index];
          var pageYScroll = window.scrollY || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      }
    };
  },
  directives: {
    TransferDom: TransferDom
  },
  computed: {
    bodyBottom: function bodyBottom() {
      return this.repairInfo.repairState !== '1' ? '0.64rem' : '0';
    }
  },
  methods: {
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    showSecond: function showSecond(index) {
      this.$refs.previewerSecond.show(index);
    },
    submitData: function submitData(type) {
      var _this = this;

      this.$utils.Tools.loadShow();
      var params = {};

      if (type === '0') {
        params = {
          id: this.$route.params.state,
          readFlag: '1'
        };
      } else {
        var temp = [];

        var _iterator = _createForOfIteratorHelper(this.doneImgList),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var imgs = _step.value;
            temp.push(imgs.serverId);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var imgPath = temp.join(',');
        params = {
          id: this.$route.params.state,
          repairRemark: this.repairRemark,
          resultPhoto: imgPath,
          repairState: '1'
        };
      }

      this.$api.Repairs.updateByPrimaryKey(params).then(function (response) {
        _this.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg;

        if (+code !== _this.$code.success) {
          _this.$utils.Tools.toastShow(msg);
        } else {
          _this.$utils.Tools.toastShow(msg);

          if (_this.$route.params.notification) {
            setTimeout(function () {
              window.location.reload();
            }, 1000);
          } else {
            _this.$router.replace('/RepairAppList');
          }
        }
      }).catch(function () {
        _this.$utils.Tools.httpError();
      });
    },
    getRepairInfo: function getRepairInfo() {
      var _this2 = this;

      this.$utils.Tools.loadShow();
      this.$api.Repairs.selectByPrimaryKey(this.$route.params.state).then(function (response) {
        _this2.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this2.$code.success) {
          _this2.$utils.Tools.toastShow(msg);
        } else {
          _this2.repairInfo = data;

          if (data.photoList != null) {
            for (var i = 0; i < data.photoList.length; i++) {
              _this2.imgList.push({
                src: data.photoList[i],
                msrc: data.photoList[i]
              });
            }
          }

          if (data.resultPhotoList != null) {
            for (var _i = 0; _i < data.resultPhotoList.length; _i++) {
              _this2.showImgList.push({
                src: data.resultPhotoList[_i],
                msrc: data.resultPhotoList[_i]
              });
            }
          }
        }
      }).catch(function () {
        _this2.$utils.Tools.httpError();
      });
    }
  },
  created: function created() {
    this.getRepairInfo();
  },
  mounted: function mounted() {
    this.$utils.Store.setItem('repairApp', this.$route.params.index);

    if (this.$route.params.notification) {
      this.$utils.Tools.pushHistory();
    }
  },
  destroyed: function destroyed() {}
};